import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AdminSideBar from "../components/Header/AdminSideBar";
import Logo from "../assets/logo.svg";
import TopBar from "../components/Header/TopBar";
import Footer from "../components/Header/Footer";

const pageTitles = {
  "/landlod": "Overview",
  "/landlod/managelands": "Property Details: Units & Tenants",
  "/landlod/payments/:unitId": "View Payments",
  "/landlod/paymentmonitoring": "Notification Center",
  "/landlod/legalSupport": "Legal Support",
  "/landlod/reqMaintaince": "Request Maintenance",
  "/landlod/taxConsulation": "Tax Consultation Request",
  "/landlod/paymonitoring": "Payment Monitoring",
  "/landlod/support-email-settings": "Support Email Settings",
  "/landlod/support-logs": "Support Logs",
  "/landlod/tenant-payment-activity": "Tenant Payment Activity",
  "/landlod/admin-manage-landload": "Manage Landlods",
  "/landlod/admin-manage-landload/profile": "Landlord Profile",
  "/landlod/admin-payout": "Payouts",
  "/landlod/admin-payment-history": "Payment History",
};

const AdminLayout = () => {
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const matchedPath = Object.keys(pageTitles)?.find((path) =>
    location.pathname.startsWith(path)
  );

  const title = matchedPath ? (
    pageTitles[matchedPath]
  ) : (
    <img src={Logo} alt="Roselea Logo" className="h-10 hidden md:flex" />
  );

  const userProfile = {
    name: user
      ? `${user.firstName || ""} ${user.lastName || ""}`.trim()
      : "Admin",
    profilePicture: user?.profilePicture || null,
    email: user?.email || null,
    ...user,
  };

  return (
    <>
      <div className="h-screen flex flex-col">
        {/* TopBar */}
        <div className="h-[79px] flex-shrink-0">
          <TopBar
            title={title}
            user={userProfile}
            onHamburgerClick={() => setSidebarOpen(true)}
          />
        </div>

        {/* Sidebar + Main Content Layout */}
        <div className="flex flex-1 overflow-hidden">
          {/* Sidebar */}
          <AdminSideBar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />

          {/* Main Content */}
          <div className="flex-1 bg-[#F5F7FA] overflow-y-auto pb-10 md:px-4">
            <Outlet />
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default AdminLayout;
